import { z } from "zod";
export const NaturalWorkAdmissionReasonSchema = z.enum([
    "DIRECT_REQUEST",
    "COMMITMENT",
    "WORK_REQUIREMENT",
    "IMPERATIVE",
    "DEADLINE",
    "CONTEXT_CONTINUATION"
]);
const PhraseListSchema = z.array(z.string().trim().min(1).max(100)).min(1).max(200);
/** Industry vocabulary belongs to a workflow pack, not the channel adapter.
 * A new business can replace these bounded phrases without changing WhatsApp,
 * the database, model authority, proposal execution, or the Work UI. */
export const NaturalWorkRuleSetSchema = z.object({
    version: z.string().trim().min(1).max(100),
    actionVerbs: PhraseListSchema,
    deliverableTerms: PhraseListSchema,
    requestPhrases: PhraseListSchema,
    commitmentPhrases: PhraseListSchema,
    requirementPhrases: PhraseListSchema,
    contextConfirmationPhrases: PhraseListSchema,
    deadlineTerms: PhraseListSchema,
    ignoreExactPhrases: PhraseListSchema
}).strict();
//# sourceMappingURL=natural-work-rules.js.map